<template>
  <zul-modal id="support-modal" class="is-medium" ref="modal" title="" primary="Enviar" @primary="send()">
    <p class="subtitle">Olá<span v-if="$auth.check()">, {{ ticket.context.name }}</span>! Utilize o formulário abaixo para entrar em contato com o nosso time:</p>
    <fieldset v-if="step === 1" class="form">
      <zul-input ref="inputName" type="text" v-model="ticket.context.name" name="ticket-name" label="Nome" v-show="!$auth.check()"></zul-input>
      <zul-input type="email" v-model="ticket.context.email" name="ticket-email" label="E-mail" v-show="!$auth.check()"></zul-input>
      <zul-input ref="inputSubject" type="text" v-model="ticket.subject" name="ticket-subject" v-validate="'required'" label="Assunto"></zul-input>
      <zul-textarea v-model="ticket.message" name="ticket-message" v-validate="'required'" label="Mensagem"></zul-textarea>
    </fieldset>
    <fieldset v-else class="success">
      <span class="icon is-success"></span>
      <p>Sua mensagem foi enviada, você receberá uma resposta por e-mail em breve.</p>
    </fieldset>
  </zul-modal>
</template>

<script>
export default {
  props: {},
  data () {
    return {
      ticket: this.defaultValues(),
      step: 1
    }
  },
  mounted () {
    this.$root.$on('open-support-modal', () => {
      this.$refs.modal.open()
      
      if (this.ticket.context.name) {
        this.$refs.inputSubject.focus()
      } else {
        this.$refs.inputName.focus()
      }

    })
    this.$root.$on('close-support-modal', () => {
      this.close()
    })
    this.$root.$on('reset-support-modal', this.reset)
  },
  destroyed () {
    this.$root.$off('open-support-modal')
    this.$root.$off('close-support-modal')
    this.$root.$off('reset-support-modal')
  },
  methods: {
    defaultValues () {
      const user = this.$auth.user()

      return {
        context: {
          name: user && user.name,
          email: user && user.email
        },
        subject: '',
        message: '',
        attachment: []
      }
    },
    reset () {
      this.step = 1
      this.$refs.modal.stopLoading()
      this.$refs.modal.setProps({title: 'Enviar ticket de suporte', type: 'normal', labels: { primary: 'Enviar ticket' }})
      this.ticket = this.defaultValues()
      this.$validator.reset()
    },
    send () {
      this.$refs.modal.startLoading()

      if (this.step === 2) {
        this.$root.$emit('close-support-modal')
      }

      this.GAE.post('/ticket', this.ticket)
        .then(() => {
          this.step = 2
          this.$refs.modal.setProps({title: 'Ticket enviado', type: 'neutral', labels: { primary: 'Fechar' }})
          this.$refs.modal.stopLoading()
        })
    },
    close () {
      this.$refs.modal.close()
      this.reset()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/sass/variables';

  .success {
    border: none;
    text-align: center;

    .icon {
      margin: 10px auto;
    }
  }
</style>